import { useState } from 'react';
import { FormControlLabel,Switch } from '@mui/material';
export const IsRequiredQuestion = ({ isRequired, onChangeSwitch }) => {
  const handleChange = (event) => {
    onChangeSwitch(event);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          name="isRequired"
          checked={isRequired}
          onChange={handleChange}
          color="primary"
        />
      }
      label="¿Es requerida?"
    />
  );
};
